import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'

const StyledComp = styled.div`
  padding: 120px 40px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.medium}) { 
    padding: 40px;
  }
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 40px;
  }

  .header__title {
    font-size: 36px;
    line-height: 1.25;
    margin: 0 0 12px;
  }

  .header__subtitle {
    font-size: 15px;
    line-height: 1.5;
    color: #6b7280;
    max-width: 480px;
    margin: 0;
  }

  .header__link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    font-size: 14px;
    text-decoration: none;
    white-space: nowrap;
    margin-top: 4px;
  }

  .header__link svg {
    width: 14px;
    height: 14px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .card {
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: #f9f9f9;
    border-radius: 12px;
    padding: 12px;
  }

  .card--wide {
    grid-column: span 2;
  }

  .card__visual {
    max-width: 100%;
    min-width: 100%;
    border-radius: 8px;
    margin-bottom: 28px;
    height: auto;
  }

  .card--wide .card__visual {
    // height: 220px;
  }

  .card--top .card__visual {
    // height: 180px;
  }

  .card--bottom .card__visual {
    // height: 150px;
  }

  .card__title {
    font-size: 17px;
    font-weight: 600;
    color: #111315;
    margin: 0 0 8px;
  }

  .card__desc {
    font-size: 14px;
    line-height: 1.5;
    color: #6b7280;
    margin: 0;
  }

  @media (max-width: 900px) {
    .grid {
      grid-template-columns: 1fr;
    }

    .card--wide {
      grid-column: span 1;
    }

    .header {
      flex-direction: column;
    }
  }
`;

const ChevronIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const features = [
  {
    key: 'research-time',
    variant: 'top',
    wide: true,
    img: '/devs/11.png',
    title: 'Cut quant research time',
    description: 'Fetch, organize, transform, and visualize data with a unified set of intelligent tools built for notebook-driven quant research workflows. Everything you need to move from raw information to insight, all in one place.',
    imageAlt: 'AI research query interface',
  },
  {
    key: 'be-first',
    variant: 'top',
    wide: false,
    title: 'Ready to deploy',
    description: 'Run the same powerful workflows across server and client applications. Production-ready architecture, reliable performance, and deployment-friendly tooling included.',
    img: '/devs/2.png',
    imageAlt: 'Event timeline scrubber',
  },
  {
    key: 'trust-findings',
    variant: 'bottom',
    wide: false,
    title: 'Usage & Billing that makes sense',
    description: 'Simple, predictable billing with transparent usage tracking and no hidden costs',
    img: '/devs/3.png',
    imageAlt: 'AI-cited transcript message',
  },
  {
    key: 'blind-spots',
    variant: 'bottom',
    wide: false,
    title: 'Find everything in one place',
    description: 'All your financial data in one platform, with a consistent financial data SDK interface across every asset class and dataset.',
    img: '/devs/1.png',
    imageAlt: 'Global document search bar',
  },
  {
    key: 'inflection-points',
    variant: 'bottom',
    wide: false,
    title: 'Full historical depth',
    description: 'Daily and hourly data back to 1987, with the full history of any dataset retrievable nearly instantly for long-horizon research.',
    img: '/devs/4.png',
    imageAlt: 'Deep historical chart view',
  },
];

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="header">
        <div>
          <h2 className="header__title serif">From raw numbers to real understanding</h2>
          <p className="header__subtitle">
            A market data SDK for quant research teams and finance professionals
            who need better decisions, faster.
          </p>
        </div>
        <Link className="header__link" to="/dashboard">
          Get started
          <ChevronIcon />
        </Link>
      </div>

      <div className="grid">
        {features.map((feature) => (
          <div
            key={feature.key}
            className={`card card--${feature.variant}${feature.wide ? ' card--wide' : ''}`}
          >
            <img
              className="card__visual"
              src={feature.img}
              alt={feature.imageAlt}
              width="800"
              height="400"
              loading="lazy"
            />
            <h3 className="card__title">{feature.title}</h3>
            <p className="card__desc">{feature.description}</p>
          </div>
        ))}
      </div>
    </StyledComp>
  );
};

export default Comp;
